/*下拉选项处用到*/
export const ActualMethods = [
    { name: { zh: '实际值', en: 'Actual' }, value: 'Actual' },
];

export const SamplingMethods = [
    { name: { zh: '最大值', en: 'Max' }, value: 'Max' },
    { name: { zh: '最小值', en: 'Min' }, value: 'Min' },
    { name: { zh: '平均值', en: 'Mean' }, value: 'Mean' },
    { name: { zh: '标准差', en: 'Stddev' }, value: 'Stddev' }
];

/*Echart 悬浮显示处用到*/
export const Methods = {
    'Actual': { zh: '实际值', en: 'Actual' },
    'Max': { zh: '最大值', en: 'Max' },
    'Min': { zh: '最小值', en: 'Min' },
    'Mean': { zh: '平均值', en: 'Mean' },
    'Stddev': { zh: '标准差', en: 'Stddev' }
}
